import profile from './profile';
import campaigns from './campaigns';
import products from './products';

const index = {
  profile,
  campaigns,
  products,
};

export default index;